import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { Button } from "../../../shadcn/components/ui/button";

interface WeekDayComponentProps {
  weeklyData: Record<string, number>;
}

interface props {
  events: any;
}

const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
export const EventsCalendar = ({ events }: props) => {
  const router = useRouter();
  const today = days[new Date().getDay()];
  const [auctionCount, setAuctionCount] = useState<number>(events[today]);
  const [selectedDay, setSelectedDay] = useState<string>(today);

  useEffect(() => {
    setAuctionCount(events[today]);
  }, [events]);

  const WeekDayComponent = ({ weeklyData }: WeekDayComponentProps) => {
    if (!weeklyData) return <></>;
    const MAX_HEIGHT = 100;
    const dataArray = Object?.entries(weeklyData).map(([day, count]) => ({
      day,
      count,
    }));
    const maxCount = Math.max(...dataArray?.map((d) => d.count));
    return (
      <div className="flex sm:space-x-8 mt-2  justify-between sm:justify-center">
        {weeklyData &&
          Object.entries(weeklyData).map(([day, count]) => {
            const height = (count / maxCount) * MAX_HEIGHT;
            return (
              <div
                key={day}
                className={`flex flex-col items-center justify-end ${
                  selectedDay === day ? "bg-brand-lightPink" : ""
                } px-1.5  sm:px-3 pb-3 pt-2 rounded-b-xl`}
              >
                <div
                  className={`w-[1px] border transition-all duration-300 `}
                  style={{ height: `${height}px` }}
                ></div>
                <p
                  onClick={() => {
                    setAuctionCount(events[day] || 0);
                    setSelectedDay(day);
                  }}
                  className="h-7 w-7 font-openSans font-normal text-center py-1.5 text-web-body-sm leading-4 rounded-full bg-brand-lightBlue text-brand-textGrey hover:cursor-pointer"
                >
                  {day.slice(0, 1).toUpperCase()}
                </p>
              </div>
            );
          })}
      </div>
    );
  };

  return (
    <div className="mt-5 border border-brand-borderGreyTwo flex flex-col justify-between p-4 pb-0">
      <div className="w-full">
        <div className="flex justify-between items-center sm:items-center ">
          <p className="font-openSans font-semibold text-mobile-body-sm leading-4 lg:text-web-body-md lg:leading-5 text-brand-bgBlack">
            Events Calendar
          </p>
          <p
            onClick={() => {
              router.push("/dashboard/event-calendar");
            }}
            className="font-openSans font-semibold text-web-body-sm leading-4 text-brand-bgBlack hover:cursor-pointer"
          >
            View All
          </p>
        </div>
        <div className="flex ">
          <Button className="bg-brand-textLightGrey mx-auto hover:cursor-text">{`${auctionCount} Auctions`}</Button>
        </div>
      </div>
      <WeekDayComponent weeklyData={events} />
    </div>
  );
};

export default EventsCalendar;
